import searchIcoBPBanned from 'legacy/lut/assets/img/quick-search/BP-banned.svg'
import searchIcoBP from 'legacy/lut/assets/img/quick-search/BP.svg'
import searchIcoP1HW from 'legacy/lut/assets/img/quick-search/P1-HW-spec.svg'
import searchIcoP1Spec from 'legacy/lut/assets/img/quick-search/P1-spec.svg'
import searchIcoP1Sup from 'legacy/lut/assets/img/quick-search/P1-supplies-BP.svg'
import searchIcoRetH1 from 'legacy/lut/assets/img/quick-search/Retailer-H1.svg'
import searchIcoRetH2 from 'legacy/lut/assets/img/quick-search/Retailer-H2.svg'
import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { TPartnerProgramCode } from 'legacy/lut/classes/models/SearchItem'
import { IGroupedSearchItem, SearchApi } from 'legacy/lut/classes/services/api/SearchApi'
import { ILegalAttachment } from 'legacy/lut/components/widgets/public/partnerEditDialog/models'
import { EMarket } from 'legacy/lut/configs/geo'

import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { Logic, Operator } from 'core-components/types'
import { deleteFile } from 'core/classes/helpers/deleteFile'
import { arrayUnique } from 'core/classes/helpers/Helper'
import { saveFile } from 'core/classes/helpers/saveFiles'
import { IExtendedFileData } from 'core/classes/models/IFileData'
import { ICountry } from 'core/classes/models/IReference'
import { CrudStore } from 'core/types/crudStore'

export function getPartnerCodes(programCodes: string[]): TPartnerProgramCode[] {
  const result: TPartnerProgramCode[] = []

  arrayUnique(programCodes).forEach((programCode) => {
    if (programCode.match(/^G_PM_PF_(.*)_PAR_HW$/)) {
      result.push('P1 HW')
    }

    if (programCode.match(/^G_PM_PF_(.*)_PAR_SUP$/)) {
      result.push('P1 Sup')
    }

    if (programCode.match(/^G_SPEC_PF_(.*)/)) {
      result.push('P1 Spec')
    }
    if (programCode === 'G_PM_PF_BUS_PAR') {
      result.push('BP')
    }
    if (programCode === 'EU-PPS-C001') {
      result.push('Ret H1')
    }
    if (programCode === 'EU-PPS-C003') {
      result.push('Ret H2')
    }
    if (programCode === 'EU-DI-PSG-SBSO-BLACKLIST') {
      result.push('BP banned')
    }
  })

  return arrayUnique(result)
}

export function getPartnerProgramCodeIconsClasses(codes: TPartnerProgramCode[]): any[] {
  const result: any[] = []
  codes.forEach((code) => {
    switch (code) {
      case 'P1 Spec':
        result.push({ icon: searchIcoP1Spec, alt: code })
        break
      case 'P1 HW':
        result.push({ icon: searchIcoP1HW, alt: code })
        break
      case 'P1 Sup':
        result.push({ icon: searchIcoP1Sup, alt: code })
        break
      case 'BP':
        result.push({ icon: searchIcoBP, alt: code })
        break
      case 'BP banned':
        result.push({ icon: searchIcoBPBanned, alt: 'BP Not Addressable' })
        break
      case 'Ret H1':
        result.push({ icon: searchIcoRetH1, alt: code })
        break
      case 'Ret H2':
        result.push({ icon: searchIcoRetH2, alt: code })
        break
    }
  })
  return arrayUnique(result)
}

export async function lazyLoadProgramCodes(
  groupedPartners: IGroupedSearchItem[]
): Promise<IGroupedSearchItem[]> {
  const partnerIds: string[] = []
  groupedPartners.forEach((i) => partnerIds.push(...i.items.map((j) => j.PartnerID)))

  const programCodes = await SearchApi.fetchProgramCodes(
    partnerIds,
    0,
    1000 /*100*/,
    undefined,
    undefined,
    undefined /*filter*/
  )
  return new Promise((resolve: any) => {
    groupedPartners.forEach((draftGroupedPartner) => {
      draftGroupedPartner.items.forEach((draftPartner) => {
        const codes = programCodes.items
          .filter((i) => i['PARTNER_ID'] === draftPartner.PartnerID)
          .map((i: any) => i['Code'])
        draftPartner.programCodes = getPartnerCodes(codes)
      })
    })
    resolve([...groupedPartners])
  })
}

export const URLNotMandatory = [
  'Albania',
  'Armenia',
  'Bosnia and Herzegovina',
  'Belarus',
  'Serbia And Montenegro',
  'Kosovo',
  'Kazakhstan',
  'Moldavia',
  'Montenegro',
  'Serbia',
  'Bahrain',
  'Egypt',
  'Ethiopia',
  'Iraq',
  'Kenya',
  'Kuwait',
  'Lebanon',
  'Oman',
  'Qatar',
  'Tanzania United Republic',
  'Uganda',
  'Yemen',
  'Angola',
  'Burkina Faso',
  'Benin',
  'Botswana',
  'Congo Democratic Republic',
  'Côte d Ivoire',
  'Cameroon',
  'Algeria',
  'Gabon',
  'French Guiana',
  'Ghana',
  'Gambia',
  'Guadeloupe',
  'Liberia',
  'Lesotho',
  'Morocco',
  'Madagascar',
  'Martinique',
  'Mauritania',
  'Mozambique',
  'Namibia',
  'Nigeria',
  'French Polynesia',
  'Reunion',
  'Senegal',
  'Swaziland',
  'Tunisia',
  'Mayotte',
  'South Africa',
  'Zimbabwe',
]

const { greaterChina, greaterAsia, india, latinAmerica } = EMarket
export const urlMarkets = [greaterChina, greaterAsia, india, latinAmerica].map(String)

export const checkIsBranch = (item: DataModel) => {
  return !(
    item.get('Hierarchy') === PartnerHierarchyType.HEADQUARTERS ||
    item.get('HierarchyType') === PartnerHierarchyType.HEADQUARTERS
  )
}

export const checkHierarchy = (item: DataModel, values: string[]) => {
  let resul = false

  values.forEach((value) => {
    if (item.get('Hierarchy') === value || item.get('HierarchyType') === value) {
      resul = true
    }
  })

  return resul
}

export const checkIsHQ = (item: DataModel) => {
  return item.get('Hierarchy') === 'Headquarters' || item.get('HierarchyType') === 'Headquarters'
}

export const checkIsAmerica = (item: DataModel) => {
  return item.get('Market') === EMarket.latinAmerica || item.get('Market') === EMarket.northAmerica
}

export const getLegalFiles = async (
  entryIdItem: DataModel,
  needCacheInvalidation: boolean = false
) => {
  if (needCacheInvalidation) {
    CrudStore.get(CrudStoreItem.LegalAttachments, 'getLegalFiles').removeQueries()
  }
  const pid = entryIdItem.get('PartnerID')
  const crud = CrudStore.get(CrudStoreItem.LegalAttachments, 'getLegalFiles')
  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        operator: Operator.EQUAL,
        field: 'PartnerId',
        value: pid,
      },
      {
        operator: Operator.EQUAL,
        field: 'Type',
        value: 'legal',
      },
    ],
  })
  crud.setPaging({
    page: 0,
    pageSize: 20,
  })
  const result = await crud.fetch()
  return result.items as ILegalAttachment[]
}

export const updateLegalFiles = async (
  entryIdItem: DataModel,
  fileLoaders: Array<IExtendedFileData & { formCode: string }>,
  legalFiles: ILegalAttachment[]
) => {
  const formId = 672
  const formCode = 'LegalAttachments'
  const attachFieldName = 'Attachment'

  const legalAttachmentsSource = CrudStore.get(CrudStoreItem.LegalAttachments)

  const existingFiles = await getLegalFiles(entryIdItem)
  const filesToDelete = existingFiles.filter(
    (el) => !legalFiles.find((legalFile) => legalFile.EntryId === el.EntryId)
  )
  Promise.all(
    filesToDelete.map((i) =>
      deleteFile({
        formId,
        formCode,
        entryId: i.EntryId,
        UID: i.UID,
        fileName: i.Attachment,
        fieldName: attachFieldName,
        source: legalAttachmentsSource,
      })
    )
  )

  if (fileLoaders.length) {
    const modelsToSave = fileLoaders.map(({ file }) => ({
      PartnerId: entryIdItem.get('PartnerID'),
      Type: 'legal',
      file,
    }))
    await saveFile({
      formId,
      formCode,
      fieldName: attachFieldName,
      models: modelsToSave,
      source: legalAttachmentsSource,
    })
    legalAttachmentsSource.removeQueries()
  }
}

export const getCountryByName = (countryName: string, countries: ICountry[]) => {
  return countries.find((el) => el.name === countryName)
}
